/**
 * EplStatusBadge - Badge de estado para laboratorios
 * 
 * Muestra el estado del laboratorio con íconos SVG y colores apropiados
 * Sin usar emoticones (política de diseño)
 */

import React from 'react';
import { CheckCircle, Lock, Clock, Archive, AlertTriangle } from 'lucide-react';

const EplStatusBadge = ({ status, className = '' }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'active':
        return {
          icon: CheckCircle,
          text: 'Disponible',
          bgColor: 'bg-green-100',
          textColor: 'text-green-800',
          iconColor: 'text-green-600'
        };
      case 'disabled':
        return {
          icon: Lock,
          text: 'No disponible',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          iconColor: 'text-gray-600'
        };
      case 'draft':
        return {
          icon: Clock,
          text: 'Borrador',
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          iconColor: 'text-yellow-600'
        };
      case 'archived':
        return {
          icon: Archive,
          text: 'Archivado',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-700',
          iconColor: 'text-gray-500'
        };
      case 'maintenance':
        return {
          icon: AlertTriangle,
          text: 'Mantenimiento',
          bgColor: 'bg-orange-100',
          textColor: 'text-orange-800',
          iconColor: 'text-orange-600'
        };
      default:
        return {
          icon: Clock,
          text: 'Desconocido',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-600',
          iconColor: 'text-gray-400'
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor} ${className}`}>
      <Icon className={`w-3.5 h-3.5 ${config.iconColor}`} />
      {config.text}
    </span>
  );
};

export default EplStatusBadge;
